import Model from 'flarum/common/Model';

/**
 * Mirrors Ziiven\Topics\Api\Resource\TopicResource.
 *
 * `name` is the display casing (as first written by whoever used it first);
 * `nameKey` is the case-folded form the routes and filters match on. Anything
 * user-facing shows `name`, anything addressable uses `nameKey`.
 */
export default class Topic extends Model {
  name() {
    return Model.attribute('name').call(this);
  }
  nameKey() {
    return Model.attribute('nameKey').call(this);
  }
  postCount() {
    return Model.attribute('postCount').call(this);
  }
  discussionCount() {
    return Model.attribute('discussionCount').call(this);
  }
  lastUsedAt() {
    return Model.attribute('lastUsedAt', Model.transformDate).call(this);
  }

  /**
   * The weighted heat score — the number the ranking uses. A curator's manual
   * weight is already folded in; the raw score is not exposed.
   */
  heatScore() {
    return Model.attribute('heatScore').call(this);
  }

  /**
   * The heat tier, 1–5. A topic whose heat has never been computed comes
   * back as 0 and is shown as the lowest tier.
   */
  heatLevel() {
    return Model.attribute('heatLevel').call(this);
  }

  /**
   * The trend as a ratio: 0.18 means +18%. Null means there is no history to
   * compare against yet. The sign and the unit belong to the front end.
   */
  heatTrend() {
    return Model.attribute('heatTrend').call(this);
  }
}
flarum.reg.add('ziiven-topics', 'forum/models/Topic', Topic);